import React from "react";

/**
 * AuthorSignature — signature auteur publique (Phase 13.c).
 *
 * Rendu discret en bas d'article. Omission gracieuse si aucune identité
 * publique n'est configurée (backend renvoie `public_author = null`).
 * Champs publics uniquement : display_name / public_alias / public_bio /
 * public_avatar_url / editorial_title. Jamais email / rôle / UUID.
 */
export function AuthorSignature({ author, fallbackName }) {
  if (!author) return null;
  const name = author.display_name || author.public_alias || fallbackName;
  if (!name && !author.public_bio) return null;

  const initials = (name || "?")
    .split(" ")
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <aside
      className="mt-12 md:mt-16 border-t border-border pt-8 flex items-start gap-4"
      data-testid="author-signature"
    >
      <div className="flex-shrink-0">
        {author.public_avatar_url ? (
          <img
            src={author.public_avatar_url}
            alt={name || "Auteur"}
            className="w-14 h-14 rounded-full object-cover border border-border"
            data-testid="author-signature-avatar"
          />
        ) : (
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center text-primary font-heading font-semibold">
            {initials}
          </div>
        )}
      </div>
      <div className="min-w-0">
        {name && (
          <p className="font-heading text-base font-semibold text-primary" data-testid="author-signature-name">
            {name}
          </p>
        )}
        {author.editorial_title && (
          <p className="text-sm text-accent" data-testid="author-signature-title">
            {author.editorial_title}
          </p>
        )}
        {author.public_bio && (
          <p className="text-sm text-muted-foreground mt-2 leading-relaxed" data-testid="author-signature-bio">
            {author.public_bio}
          </p>
        )}
      </div>
    </aside>
  );
}

export default AuthorSignature;
